import template from './removePeriod.html';
import controller from './removePeriod.controller';
import './removePeriod.scss';

let removePeriodComponent = {
  restrict: 'E',
  bindings: {
    modalId: '@',
    onRemove:'&',
    onError: '&',
    userId: '<',
    userInceptionId: '<',
    isInception: '<',
    isMobileApp: '<'
  },
  template,
  controller
};

export default removePeriodComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/modals/modalRemovePeriod/removePeriod/removePeriod.component.js